module.exports = {"640522100":"海城镇","640522101":"李旺镇","640522103":"西安镇","640522104":"三河镇","640522105":"七营镇","640522200":"史店乡","640522201":"树台乡","640522202":"关桥乡","640522206":"高崖乡","640522207":"郑旗乡","640522208":"贾塘乡","640522209":"曹洼乡","640522210":"九彩乡","640522211":"李俊乡","640522212":"红羊乡","640522213":"关庄乡","640522214":"甘城乡","640522400":"种羊场","640522401":"南华山自然保护区管理处","640522402":"老城管理办公室","640522406":"海兴开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640522.json
// module id = 3188
// module chunks = 0